module.exports = __webpack_public_path__ + "img/sn.61d910b6.svg";